export default function attachAdvancedSettings() {
    const $areAdvancedSettingsEnabled = $('#are_advanced_settings_enabled');

    $areAdvancedSettingsEnabled.on('change', function () {
        $('.advanced_settings').slideToggle();
        $('.anty_advanced_settings').slideToggle();
    });
}
